import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { OfficeService } from '../shared/office.service';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';

@Component({
  selector: 'app-office-list',
  templateUrl: 'office-list.component.html',
})

export class OfficeListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] = ['Aplicaciones', 'OfficeID','EMPRESA', 'Name', 'Direccion', 'Referencia', 'Status'];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(private loaderService: LoaderService, private officeService: OfficeService,
    private errorService: ErrorService, private notificationService: NotificationService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.pageSize = 0; //CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.msgErrorGet = 'Error al listar las oficinas';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
  }

  handleRowClick(row: any, event: any) {
    if(event.srcElement.cellIndex)
    {
      if(event.srcElement.cellIndex != 0){
        this.selectedRowIndex = row.ID;
        this.data.office = { ID: row.ID, Name: row.Name };
        this.changeEvent({ evento: EVENTO.consultar, data: this.data });
      }
    }
  }

  aplicacionesRowClick(cell: any) {
    this.selectedRowIndex = cell.ID;
    this.data.office = { ID: cell.ID, Name: cell.Name };
    this.changeEvent({ evento: EVENTO.asignar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    // this.paginator.length = this.pageEvent.length;
    // this.paginator.pageIndex = this.pageEvent.pageIndex;
    // this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarOffice(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarOffice(this.sectionBarComponent.filtro);
  }

  buscarOffice(filtro: string) {
    this.clearMatPaginator();
    this.listarOffice(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarOffice(filtro: string): void {
    this.loaderService.show();
    this.officeService.listarOffice(filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
    .subscribe(res => {
      this.dataSource = new GridDataSource(res);
      this.showHideMessageGridEmpty(Number(res.length));
      this.pageEvent.length = res.length;
      this.setMatPaginator();
    },
    error => {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

